export function sanitizeForFirestore<T>(input: T): T {
  return _sanitize(input, "$") as T;
}

// biome-ignore lint/suspicious/noExplicitAny: Because
function _sanitize(v: any, path: string): any {
  if (v === undefined) return null; // or: throw with path
  if (v === null || typeof v === "string" || typeof v === "boolean") return v;

  if (typeof v === "number") {
    // Firestore rejects NaN/Infinity
    return Number.isFinite(v) ? v : null;
  }

  if (v instanceof Date) return v; // Firestore will store as Timestamp
  if (Array.isArray(v)) return v.map((x, i) => _sanitize(x, `${path}[${i}]`));

  if (typeof v === "object") {
    // biome-ignore lint/suspicious/noExplicitAny: Because
    const out: Record<string, any> = {};
    for (const [k, val] of Object.entries(v)) {
      if (val === undefined) continue; // omit undefined keys entirely
      out[k] = _sanitize(val, `${path}.${k}`);
    }
    return out;
  }

  // functions, symbols, etc.
  return null;
}
